module.exports = __webpack_public_path__ + "img/img3.87689ce9.png";